module.exports = __webpack_public_path__ + "static/media/b-arts-major-10_LR.50b92db6.jpg";